module.exports = __webpack_public_path__ + "d59dab6817cadbbc4ae022fd92247429.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/beard-yellow-s.png
// module id = 2307
// module chunks = 0